import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddTagRequestPayload } from '@app-shared/interfaces/common/tags.model';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  // Injections
  private http = inject(HttpClient);

  // Add Tag Reference
  addTagReference(tag: AddTagRequestPayload): Observable<{ tagId: string }> {
    return this.http.post<{ tagId: string }>(`/tagReferences`, tag);
  }

  // Delete Tag Reference
  deleteTagReference(tagId: string, referenceId: string): Observable<void> {
    return this.http.delete<void>(`/tagReferences/${tagId}/${referenceId}`);
  }

  // Get Distinct Column Values
  getDistinctColumnValues(params: any): Observable<string[]> {
    return this.http.get<string[]>(`/tagReferences/distinctColumnValues`, {
      params: params
    });
  }
}
